import { IOverviewMetricsChartTitleProps as IOverviewMetricsChartHeaderProps } from "@/pages/dashboard/pages/overview/components/OverviewMetricsChart/components/OverviewMetricsChartHeader/type";
import { useLocal } from "@/pages/dashboard/utils/customHook";
import { getName } from "@home/utils/common";
import React from "react";
import classNames from 'classnames';
import './index.scss';

export const OverviewMetricsChartHeader = ({
  className,
  style,
  config,
  titleEn,
  titleCn,
  subTitleComponent,
  titleRightSlot,
}: IOverviewMetricsChartHeaderProps) => {
  const { isEN } = useLocal();
  const { showSubTitle } = config || {};

  return (
    <div
      className={classNames('dbd-overview-metrics-chart-header', className)}
      style={style}
    >
      <div className="dbd-overview-metrics-chart-header__row">
        <div className="dbd-overview-metrics-chart-header__title">
          {getName(isEN, titleEn, titleCn)}
        </div>
        {titleRightSlot ? (
          <div className="dbd-overview-metrics-chart-header__title-right">
            {titleRightSlot}
          </div>
        ) : null}
      </div>
      {showSubTitle && (
        <div className="dbd-overview-metrics-chart-header__sub-title">
          {subTitleComponent}
        </div>
      )}
    </div>
  );
};
